import { randomInteger } from '@/utils';

export const SPACE_COLORS = ['yellow', 'blue', 'pink', 'primary', 'green'];

export function defaultSpaceColor() {
  return SPACE_COLORS[randomInteger(0, SPACE_COLORS.length - 1)];
}
